(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7477],{

/***/ 93547:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-hotels",
      function () {
        return __webpack_require__(8514);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ InstagramCarrousel_InstagramCarrousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ImageComponent/index.ts + 1 modules
var ImageComponent = __webpack_require__(87050);
// EXTERNAL MODULE: ./node_modules/zod/v3/types.js + 4 modules
var types = __webpack_require__(45901);
// EXTERNAL MODULE: ./blocks/Carrousel/InstagramCarrousel/InstagramCarrousel.module.css
var InstagramCarrousel_module = __webpack_require__(68714);
var InstagramCarrousel_module_default = /*#__PURE__*/__webpack_require__.n(InstagramCarrousel_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./blocks/Carrousel/InstagramCarrousel/InstagramCarrousel.tsx





var InstagramCarrousel = function(param) {
    var instagramData = param.instagramData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (InstagramCarrousel_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "Instagram"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InstagramCarrousel_module_default()).imageContainer,
                children: instagramData.slice(0, 4).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: item.url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: (InstagramCarrousel_module_default()).instagramPost,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (InstagramCarrousel_module_default()).instagramIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M9.99998 1.80184C12.6701 1.80184 12.9864 1.812 14.0408 1.86011C15.0158 1.90461 15.5453 2.06752 15.8977 2.20443C16.3644 2.38583 16.6976 2.60257 17.0475 2.95248C17.3974 3.30239 17.6142 3.63555 17.7955 4.10229C17.9325 4.4547 18.0954 4.98419 18.1399 5.95914C18.188 7.01364 18.1982 7.32989 18.1982 10C18.1982 12.6701 18.188 12.9864 18.1399 14.0409C18.0954 15.0158 17.9325 15.5453 17.7955 15.8978C17.6142 16.3645 17.3974 16.6976 17.0475 17.0476C16.6976 17.3975 16.3644 17.6142 15.8977 17.7956C15.5453 17.9325 15.0158 18.0954 14.0408 18.1399C12.9865 18.188 12.6703 18.1982 9.99998 18.1982C7.32969 18.1982 7.01344 18.188 5.95914 18.1399C4.98415 18.0954 4.45466 17.9325 4.10229 17.7956C3.63551 17.6142 3.30235 17.3975 2.95244 17.0476C2.60253 16.6976 2.38579 16.3645 2.20443 15.8978C2.06748 15.5453 1.90457 15.0158 1.86007 14.0409C1.81196 12.9864 1.8018 12.6701 1.8018 10C1.8018 7.32989 1.81196 7.01364 1.86007 5.95918C1.90457 4.98419 2.06748 4.4547 2.20443 4.10229C2.38579 3.63555 2.60253 3.30239 2.95244 2.95248C3.30235 2.60257 3.63551 2.38583 4.10229 2.20443C4.45466 2.06752 4.98415 1.90461 5.9591 1.86011C7.0136 1.812 7.32985 1.80184 9.99998 1.80184ZM9.99998 0C7.28412 0 6.94362 0.0115116 5.87701 0.0601777C4.81259 0.108764 4.08569 0.277786 3.44958 0.525007C2.79199 0.780564 2.23432 1.1225 1.67839 1.67843C1.12246 2.23436 0.780524 2.79203 0.524967 3.44962C0.277746 4.08573 0.108725 4.81263 0.060138 5.87705C0.0114719 6.94362 0 7.28416 0 10C0 12.7159 0.0114719 13.0564 0.060138 14.123C0.108725 15.1874 0.277746 15.9143 0.524967 16.5504C0.780524 17.208 1.12246 17.7657 1.67839 18.3216C2.23432 18.8775 2.79199 19.2195 3.44958 19.475C4.08569 19.7223 4.81259 19.8913 5.87701 19.9399C6.94362 19.9885 7.28412 20 9.99998 20C12.7158 20 13.0564 19.9885 14.1229 19.9399C15.1874 19.8913 15.9143 19.7223 16.5504 19.475C17.208 19.2195 17.7656 18.8775 18.3216 18.3216C18.8775 17.7657 19.2194 17.208 19.475 16.5504C19.7222 15.9143 19.8912 15.1874 19.9398 14.123C19.9885 13.0564 20 12.7159 20 10C20 7.28416 19.9885 6.94362 19.9398 5.87705C19.8912 4.81263 19.7222 4.08573 19.475 3.44962C19.2194 2.79203 18.8775 2.23436 18.3216 1.67843C17.7656 1.1225 17.208 0.780564 16.5504 0.525007C15.9143 0.277786 15.1874 0.108764 14.1229 0.0601777C13.0564 0.0115116 12.7158 0 9.99998 0ZM9.99998 4.86487C7.16393 4.86487 4.86483 7.16397 4.86483 10C4.86483 12.8361 7.16393 15.1352 9.99998 15.1352C12.836 15.1352 15.1351 12.8361 15.1351 10C15.1351 7.16397 12.836 4.86487 9.99998 4.86487ZM9.99998 13.3334C8.15904 13.3334 6.66663 11.841 6.66663 10C6.66663 8.15908 8.15904 6.66667 9.99998 6.66667C11.8409 6.66667 13.3333 8.15908 13.3333 10C13.3333 11.841 11.8409 13.3334 9.99998 13.3334ZM16.538 4.66199C16.538 5.32474 16.0008 5.86201 15.338 5.86201C14.6753 5.86201 14.138 5.32474 14.138 4.66199C14.138 3.99924 14.6753 3.462 15.338 3.462C16.0008 3.462 16.538 3.99924 16.538 4.66199Z",
                                            fill: "#F9F7F3"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageComponent/* Image */.E, {
                                    src: item.image,
                                    alt: "instagram post"
                                })
                            ]
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var InstagramCarrousel_InstagramCarrousel = (InstagramCarrousel);
// -----------------//
// type definitions //
// -----------------//
var InstagramCarrouselSchema = types/* object */.Ry({
    instagramData: types/* array */.IX(types/* object */.Ry({
        id: types/* string */.Z_(),
        image: types/* string */.Z_(),
        url: types/* string */.Z_().url()
    }))
});

;// CONCATENATED MODULE: ./blocks/Carrousel/index.ts



/***/ }),

/***/ 34244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30918);
/* harmony import */ var data_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84749);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _JoinNow_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41996);
/* harmony import */ var _JoinNow_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_JoinNow_module_css__WEBPACK_IMPORTED_MODULE_4__);





var JoinNow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_JoinNow_module_css__WEBPACK_IMPORTED_MODULE_4___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons__WEBPACK_IMPORTED_MODULE_1__/* .LittleEmperorsIcon */ .IX, {
                color: data_constants__WEBPACK_IMPORTED_MODULE_2__/* .colorConstants.black */ .Q_.black,
                className: (_JoinNow_module_css__WEBPACK_IMPORTED_MODULE_4___default().logo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: "Join now"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Sign up to Little Emperors to start taking advantage of our preferential rates and complimentary benefits"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: data_constants__WEBPACK_IMPORTED_MODULE_2__/* .navigationPaths.MEMBERSHIP */ .aY.MEMBERSHIP,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: (_JoinNow_module_css__WEBPACK_IMPORTED_MODULE_4___default().button),
                    children: "Select membership"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (JoinNow);


/***/ }),

/***/ 52260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var embla_carousel_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57434);
/* harmony import */ var components_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30918);
/* harmony import */ var _Carousel_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41571);
/* harmony import */ var _Carousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);








var defaultOptions = {
    align: "start",
    loop: false,
    containScroll: "trimSnaps",
    draggable: false,
    breakpoints: {
        "(max-width: 767px)": {
            draggable: true
        }
    },
    showNumber: false
};
var Carousel = function(param) {
    var _options = param.options, options = _options === void 0 ? defaultOptions : _options, children = param.children, customStyles = param.customStyles, minimumScrollDistance = param.minimumScrollDistance;
    var mergedOptions = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, defaultOptions, options);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,embla_carousel_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(mergedOptions), 2), emblaRef = ref[0], emblaApi = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), canScrollPrev = ref1[0], setCanScrollPrev = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), canScrollNext = ref2[0], setCanScrollNext = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), currentSlide = ref3[0], setCurrentSlide = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), totalSlides = ref4[0], setTotalSlides = ref4[1];
    var onScrollPrev = function() {
        if (!emblaApi) return;
        emblaApi.scrollPrev();
        updateScrollButtons();
    };
    var onScrollNext = function() {
        if (!emblaApi) return;
        emblaApi.scrollNext();
        updateScrollButtons();
        /**
     * This is to disable scrolling when the final scroll amount is very small
     */ if (minimumScrollDistance != null && minimumScrollDistance > 0 && !options.loop) {
            var engine = emblaApi.internalEngine();
            var currentIndex = emblaApi.selectedScrollSnap();
            var prevTarget = engine.target.get();
            // fake scroll to check distance to next slide
            emblaApi.scrollNext();
            var nextTarget = engine.target.get();
            var nextScrollDistance = Math.abs(nextTarget - prevTarget);
            if (nextScrollDistance < minimumScrollDistance) {
                setCanScrollNext(false);
            } else {
                setCanScrollNext(true);
            }
            // cancel scroll by scrolling to current slide
            emblaApi.scrollTo(currentIndex);
        }
    };
    var updateScrollButtons = function() {
        if (!emblaApi) return;
        setCanScrollPrev(emblaApi.canScrollPrev());
        setCanScrollNext(emblaApi.canScrollNext());
        setCurrentSlide(emblaApi.selectedScrollSnap() + 1);
    };
    var updateSlideNumbers = function() {
        if (!emblaApi) return;
        setTotalSlides(emblaApi.slideNodes().length);
        setCurrentSlide(emblaApi.selectedScrollSnap() + 1);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!emblaApi) return;
        var handleResize = function() {
            updateScrollButtons();
            updateSlideNumbers();
        };
        emblaApi.on("select", updateScrollButtons);
        emblaApi.on("resize", handleResize);
        // Initialize slide numbers and button states
        updateSlideNumbers();
        updateScrollButtons();
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, [
        emblaApi
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default().carouselContainer), customStyles === null || customStyles === void 0 ? void 0 : customStyles.carouselContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default().carouselButtons), customStyles === null || customStyles === void 0 ? void 0 : customStyles.carouselButtons),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: onScrollPrev,
                        disabled: !canScrollPrev,
                        className: customStyles === null || customStyles === void 0 ? void 0 : customStyles.carouselPrevButton,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons__WEBPACK_IMPORTED_MODULE_2__/* .ArrowLeft */ .Xd, {})
                    }),
                    mergedOptions.showNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default().slideNumber),
                        children: [
                            currentSlide,
                            "/",
                            totalSlides
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: onScrollNext,
                        disabled: !canScrollNext,
                        className: customStyles === null || customStyles === void 0 ? void 0 : customStyles.carouselNextButton,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons__WEBPACK_IMPORTED_MODULE_2__/* .ArrowRight */ .ol, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default().carouselViewport), customStyles === null || customStyles === void 0 ? void 0 : customStyles.carouselViewport),
                ref: emblaRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_7___default().carouselSlidesContainer), customStyles === null || customStyles === void 0 ? void 0 : customStyles.carouselSlidesContainer),
                    children: children
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);


/***/ }),

/***/ 8514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ our_hotels; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./blocks/Carrousel/index.ts + 1 modules
var Carrousel = __webpack_require__(96188);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./blocks/Inspiration/InspirationList.tsx



var InspirationList = function(param) {
    var inspiration = param.inspiration;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "inspirationList",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inspirationList__card",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "inspirationList__card-image",
                    children: inspiration.image && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: inspiration.image,
                        alt: inspiration.name,
                        width: 704,
                        height: 195
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "inspirationList__card-info",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: inspiration.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: inspiration.description
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Inspiration_InspirationList = (InspirationList);

// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
;// CONCATENATED MODULE: ./blocks/Inspiration/Inspiration.tsx













var initialInspirationItemState = {
    showAll: false
};
var Inspiration = function(param) {
    var inspirations = param.inspirations;
    var ref = (0,react.useState)(initialInspirationItemState), state = ref[0], setState = ref[1];
    var inspiration_text = (0,useLocalised/* default */.Z)(translationKeys.inspiration);
    var view_all_text = (0,useLocalised/* default */.Z)(translationKeys.view_all);
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* breakpoints.sm */.AV.sm, ")"));
    var handleClickOnViewAll = (0,react.useCallback)(function() {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showAll: true
            });
        });
    }, []);
    var handleClick = function(inspiration) {
        router_default().push({
            pathname: "/search-results-inspirations/[inspirationId]",
            query: {
                inspirationId: inspiration.id
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "inspiration",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inspiration__title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: inspiration_text
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: state.showAll ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inspiration__outerWrapper",
                        children: inspirations.map(function(inspiration, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return handleClick(inspiration);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inspiration_InspirationList, {
                                    inspiration: inspiration
                                })
                            }, index);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inspiration__outerWrapper",
                        children: [
                            inspirations.slice(0, 4).map(function(inspiration, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: function() {
                                        return handleClick(inspiration);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inspiration_InspirationList, {
                                        inspiration: inspiration
                                    })
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                title: view_all_text,
                                onClick: handleClickOnViewAll,
                                buttonType: Button/* FILLED_BUTTON_TYPE */.ME,
                                className: "view_all_text_button"
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "inspiration__outerWrapper",
                    children: inspirations.map(function(inspiration) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: function() {
                                return handleClick(inspiration);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inspiration_InspirationList, {
                                inspiration: inspiration
                            })
                        }, inspiration.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Inspiration_Inspiration = (Inspiration);

// EXTERNAL MODULE: ./blocks/JoinNow/JoinNow.tsx
var JoinNow = __webpack_require__(34244);
// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
// EXTERNAL MODULE: ./blocks/search-bar/index.ts + 23 modules
var search_bar = __webpack_require__(42742);
// EXTERNAL MODULE: ./components/carousel/Carousel.tsx
var Carousel = __webpack_require__(52260);
// EXTERNAL MODULE: ./blocks/TopPicksCarousel/TopPicksCarousel.module.scss
var TopPicksCarousel_module = __webpack_require__(2671);
var TopPicksCarousel_module_default = /*#__PURE__*/__webpack_require__.n(TopPicksCarousel_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var next_image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./blocks/TopPickCard/TopPickCard.tsx





var TopPickCard = function(param) {
    var _hotel = param.hotel, name = _hotel.name, image = _hotel.image, location = _hotel.location, id = _hotel.id;
    var router = (0,next_router.useRouter)();
    var handleExploreOurHotelsClick = (0,react.useCallback)(function() {
        router.push(constants/* navigationPaths.OUR_HOTELS */.aY.OUR_HOTELS + "/".concat(id));
    }, [
        id,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "top-pick-card-container",
        id: id,
        onClick: handleExploreOurHotelsClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "top-pick-card-container__imageWrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((next_image_default()), {
                    src: image,
                    alt: name,
                    layout: "fill",
                    objectPosition: "center",
                    objectFit: "cover",
                    className: "top-pick-card-container__image",
                    sizes: "(max-width: 768px) 320px, (max-width: 1024px) 100vw, 100vw"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "top-pick-card-container__gradientLayer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-pick-card-container__description-text",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-pick-card-container__divider"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-pick-card-container__location-text",
                        children: location
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TopPickCard_TopPickCard = (TopPickCard);

;// CONCATENATED MODULE: ./blocks/TopPicksCarousel/TopPicksCarousel.tsx





var TopPicksCarousel = function(param) {
    var ourHotels = param.ourHotels;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
        customStyles: (TopPicksCarousel_module_default()),
        options: {
            loop: true,
            showNumber: true
        },
        children: ourHotels.map(function(hotel) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopPickCard_TopPickCard, {
                hotel: hotel
            }, hotel.id);
        })
    });
};
/* harmony default export */ var TopPicksCarousel_TopPicksCarousel = (TopPicksCarousel);

// EXTERNAL MODULE: ./components/icons/index.ts + 18 modules
var icons = __webpack_require__(30918);
;// CONCATENATED MODULE: ./blocks/TopPicks/TopPicks.tsx









var TopPicks = function(param) {
    var ourHotels = param.ourHotels;
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* breakpoints.sm */.AV.sm, ")"));
    var moveMargin = 5; // number of pixels to move to change the current hotel
    var our_hot_picks_text = (0,useLocalised/* default */.Z)(translationKeys.our_hot_picks);
    var ref = (0,react.useState)(0), current = ref[0], setCurrent = ref[1];
    var ref1 = (0,react.useState)(false), disable = ref1[0], setDisable = ref1[1];
    var ref2 = (0,react.useState)(null), touchStart = ref2[0], setTouchStart = ref2[1];
    (0,react.useEffect)(function() {
        setCurrent(current % ourHotels.length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleCurrentChange = (0,react.useCallback)(function(newCurrent) {
        setDisable(true);
        if (newCurrent < 0) {
            newCurrent = ourHotels.length - 1;
        } else if (newCurrent >= ourHotels.length) {
            newCurrent = 0;
        }
        setCurrent(newCurrent);
        setTimeout(function() {
            setDisable(false);
        }, isMobile ? 50 : 500);
    }, [
        ourHotels.length,
        isMobile
    ]);
    var handelTouchStart = function(e) {
        setTouchStart(e.touches[0].clientX);
    };
    var handelTouchMove = function(e) {
        if (!touchStart) {
            return;
        }
        var diff = touchStart - e.touches[0].clientX;
        if (diff > moveMargin) {
            handleCurrentChange(current + 1);
        } else if (diff < -moveMargin) {
            handleCurrentChange(current - 1);
        }
        setTouchStart(null);
    };
    var Selectors = function(param) {
        var current = param.current, max = param.max;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "top-picks-container__current",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowLeft */.Xd, {}),
                    onClick: function() {
                        return !disable ? handleCurrentChange(current - 1) : null;
                    },
                    buttonType: Button/* OUTLINED_BUTTON_TYPE_DARK */.Wr,
                    className: "top-picks-container__button"
                }),
                current + 1,
                "/",
                max,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRight */.ol, {}),
                    onClick: function() {
                        return !disable ? handleCurrentChange(current + 1) : null;
                    },
                    buttonType: Button/* OUTLINED_BUTTON_TYPE_DARK */.Wr,
                    className: "top-picks-container__button"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "top-picks-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "top-picks-container__menu",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "top-picks-container__title",
                    children: our_hot_picks_text
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopPicksCarousel_TopPicksCarousel, {
                ourHotels: ourHotels
            })
        ]
    });
};
/* harmony default export */ var TopPicks_TopPicks = (TopPicks);

;// CONCATENATED MODULE: ./pages/our-hotels/index.tsx











var OurHotels = function(param) {
    var globalLayoutProps = param.globalLayoutProps, hotels = param.hotels, inspirations = param.inspirations, instagram = param.instagram;
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* breakpoints.sm */.AV.sm, ")"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar/* default */.Z, {
                inspirations: inspirations,
                initialSearchValue: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopPicks_TopPicks, {
                ourHotels: hotels
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Inspiration_Inspiration, {
                        inspirations: inspirations
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinNow/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "outOfBounds",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carrousel/* InstagramCarrousel */.O, {
                    instagramData: instagram
                })
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var our_hotels = (OurHotels);


/***/ }),

/***/ 68714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"InstagramCarrousel_container__c2Df_","imageContainer":"InstagramCarrousel_imageContainer__ekEaT","instagramPost":"InstagramCarrousel_instagramPost__e76QY","instagramIcon":"InstagramCarrousel_instagramIcon__G4D32"};

/***/ }),

/***/ 41996:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JoinNow_container__CZGG2","logo":"JoinNow_logo__bCwEI","button":"JoinNow_button__n6kDx"};

/***/ }),

/***/ 2671:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carouselSlidesContainer":"TopPicksCarousel_carouselSlidesContainer__exKil","carouselButtons":"TopPicksCarousel_carouselButtons__rZW4C"};

/***/ }),

/***/ 41571:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"Carousel_carouselContainer__d5Wj7","carouselButtons":"Carousel_carouselButtons__hTdeG","slideNumber":"Carousel_slideNumber__b_PYH","carouselViewport":"Carousel_carouselViewport__tqTky","carouselSlidesContainer":"Carousel_carouselSlidesContainer__7YODj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7295,5675,5901,1608,1736,6492,7434,4520,5989,2394,2742,9774,2888,179], function() { return __webpack_exec__(93547); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);